import "./shift_list.page.style.scss";
import { FC } from "react";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import useShiftListViewModel from "./shift_list.page.view_model";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import ButtonComponent from "../../../components/button/ButtonComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import NotResultsComponent from "../../../components/noResults/NoResultsComponent";
import ShiftEntity, { ShiftStatus } from "../../../../domain/entities/ShiftEntity";

const ShiftListPage: FC<{}> = () => {
    const {
        formInfo,
        result,
        i18n,
        _handleSearch,
        _handleChangeTextSearch,
        _handleChange,
        _handleOnChangePage,
        _handleOnClickDeleteShift,
        _handleOnClickUpdateShift,
        _handleOnCreateSingleShift,
        _handleOnReasignShift,
        _canReasignShift,
    } = useShiftListViewModel();

    const { register, handleSubmit } = formInfo;

    const getStatusLabel = (status: ShiftStatus) => {
        switch (status) {
            case ShiftStatus.PENDING: return i18n("Pendiente");
            case ShiftStatus.REJECTED: return i18n("Rechazado");
            case ShiftStatus.NO_CONFIRMED: return i18n("No Confirmado");
            case ShiftStatus.WAITING_FIRST_CONFIRMATION: return i18n("Esperando Primera Confirmación");
            case ShiftStatus.WAITING_SECOND_CONFIRMATION: return i18n("Esperando Segunda Confirmación");
            case ShiftStatus.CONFIRMED_FIRST: return i18n("Primera Confirmación");
            case ShiftStatus.CONFIRMED_SECOND: return i18n("Segunda Confirmación");
            case ShiftStatus.STARTED: return i18n("Iniciado");
            case ShiftStatus.READY_TO_FINISH: return i18n("Listo para Finalizar");
            case ShiftStatus.FINISHED: return i18n("Finalizado");
            default: return status;
        }
    };

    const getStatusBadgeClass = (status: ShiftStatus) => {
        switch (status) {
            case ShiftStatus.PENDING: return "badge bg-warning";
            case ShiftStatus.REJECTED: return "badge bg-danger";
            case ShiftStatus.NO_CONFIRMED: return "badge bg-secondary";
            case ShiftStatus.WAITING_FIRST_CONFIRMATION: return "badge bg-info";
            case ShiftStatus.WAITING_SECOND_CONFIRMATION: return "badge bg-info";
            case ShiftStatus.CONFIRMED_FIRST: return "badge bg-primary";
            case ShiftStatus.CONFIRMED_SECOND: return "badge bg-primary";
            case ShiftStatus.STARTED: return "badge bg-success";
            case ShiftStatus.READY_TO_FINISH: return "badge bg-warning";
            case ShiftStatus.FINISHED: return "badge bg-success";
            default: return "badge bg-secondary";
        }
    };

    return <div className="shift_list_page">
        <LayoutComponent title={i18n("Turnos")}>
            <div className="container py-5">
                <form onSubmit={handleSubmit(_handleSearch)}>
                    <div className="row">
                        <div className="col-md-10">
                            <input type="text" className="form-control" placeholder={i18n("Buscar turnos...")} {...register("query")} onKeyUp={_handleChangeTextSearch} />
                        </div>
                        <div className="col-md-2">
                            <ButtonComponent
                                className="w-100 d-flex justify-content-center"
                                type="submit"
                                design="primaryOutline"
                                text={i18n("Buscar")}
                                icon={<span className="material-symbols-outlined">search</span>}
                            />
                        </div>
                    </div>
                </form>

                <div className="row mt-4">
                    <div className="col-md-12 d-flex justify-content-end">
                        <ButtonComponent
                            onClick={_handleOnCreateSingleShift}
                            design="primaryOutline"
                            text={i18n("Crear Turno")}
                            icon={<span className="material-symbols-outlined">add</span>}
                        />
                    </div>
                </div>

                {result == undefined ? (
                    <LoadingComponent />
                ) : (
                    <>
                        {result?.data && result.data.length > 0 ? (
                            <>
                                <div className="table-responsive mt-4">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>{i18n("Estado")}</th>
                                                <th>{i18n("Establecimiento")}</th>
                                                <th>{i18n("Empleado")}</th>
                                                <th>{i18n("Fecha Inicio")}</th>
                                                <th>{i18n("Acciones")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {result.data.map((shift: ShiftEntity) => (
                                                <tr key={shift.id}>
                                                    <td>
                                                        <span className={getStatusBadgeClass(shift.status)}>
                                                            {getStatusLabel(shift.status)}
                                                        </span>
                                                    </td>
                                                    <td>{shift.stablishment.name}</td>
                                                    <td>{shift.user.name}</td>
                                                    <td>{shift.startDate.toLocaleString()}</td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            {/* <ButtonComponent
                                                                onClick={() => _handleOnClickUpdateShift(shift)}
                                                                design="primary"
                                                                text={i18n("Editar")}
                                                                icon={<span className="material-symbols-outlined">edit</span>}
                                                            /> */}
                                                            {_canReasignShift(shift) && (
                                                                <ButtonComponent
                                                                    onClick={() => _handleOnReasignShift(shift)}
                                                                    text={i18n("Reasignar")}
                                                                    icon={<span className="material-symbols-outlined">swap_horiz</span>}
                                                                />
                                                            )}
                                                            <ButtonComponent
                                                                onClick={() => _handleOnClickDeleteShift(shift)}
                                                                design="dangerOutline"
                                                                text={i18n("Eliminar")}
                                                                icon={<span className="material-symbols-outlined">delete</span>}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-4">
                                    <PaginatorComponent
                                        resultData={result}
                                        onChangePage={_handleOnChangePage}
                                    />
                                </div>
                            </>
                        ) : (
                            <NotResultsComponent />
                        )}
                    </>
                )}
            </div>
        </LayoutComponent>
    </div>;
};

export default ShiftListPage;